<template>
	<div class="user_orders_Settings p-5">
		<b-overlay :show="is_load">
			<div class="row">
				<div class="col-lg-6 col-md-6 col-xs-12">
					<div class="info">
						<div class="panel-tag">
							{{ __t('user_billing_fields') }}
						</div>
					</div>

					<div class="cur_status">
                        <div class="panel-tag mt-2" v-if="obj_to_null(this.next_pay_date)">
                            <div>
                                {{ __t('next_pay') }} : {{this.next_pay_date}}
                            </div>
                        </div>


						<div class="need_pay mt-5" v-if="billing_data.need_pay">
							<div class="p-3 bg-danger-200 rounded overflow-hidden position-relative text-white mb-g">
								<div class="">
									<h3 class="display-4 d-block l-h-n m-0 fw-500">
										{{billing_data.costs.usd_cost}} €  = {{billing_data.costs.uah_cost}} ₴
										<small class="m-0 l-h-n">
											Не оплачен текущий месяц
										</small>
									</h3>
								</div>
								<i class="fal fa-money-bill position-absolute pos-right pos-bottom opacity-55  mb-n1 mr-n4" style="font-size: 6rem;"></i>
							</div>
						</div>

						<div class="need_pay mt-5" v-else>
							<div class="p-3 bg-success-200 rounded overflow-hidden position-relative text-white mb-g">
								<div class="">
									<h3 class="display-4 d-block l-h-n m-0 fw-500">
										 {{billing_data.costs.uah_cost}} ₴
										<small class="m-0 l-h-n">
											Все ок - оплачено
										</small>
									</h3>
								</div>
								<i class="fal fa-money-bill position-absolute pos-right pos-bottom opacity-55  mb-n1 mr-n4" style="font-size: 6rem;"></i>
							</div>
						</div>
                        <bill_graph></bill_graph>
					</div>
				</div>


				<div class="col-lg-6 col-md-6 col-xs-12">
                    <bill_payments :bills="bills" :billing_data="billing_data"></bill_payments>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>


import Bill_graph from "./billing_components/bill_graph";
import Bill_payments from "./billing_components/bill_payments";
export default {
	name: "user_billing",
    components: {Bill_payments, Bill_graph},
    data() {
		return {
			is_load: false,
            billing_data : {
                pay_url : "",
                payments : [],
                costs : {
                    uah_cost : 0
                }
            }
		}
	},


	props: {
		user: {
			type: Object
		}
	},

    mounted() {
        this.load_billing_data();
    },

	methods : {

        async load_billing_data() {
            this.is_load = true;
            await api.post('/internal/v1/billing').then(({data}) => {
                this.is_load = false;
                this.billing_data = data.data;

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async unsubscribe() {
            await api.post('/internal/user/unsubscribe').then(({data}) => {
                this.is_load = false;
                this.billing_data = data.data;

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
	},
	computed : {

	    client() {
	        if(this.user.hasOwnProperty("client")) {
	            return this.user.client;
            }

	        return {
	            'id': 0,
                'is_subscribe' : false,
            };
        },

        bills() {
            if(this.billing_data.hasOwnProperty('bills')) {
                return this.billing_data.bills;
            }

            return [];
        },

        is_subscribe() {
	        return this.client.is_subscribe;
        },

        get_next_pay() {
	        if(this.billing_data.hasOwnProperty("get_next_pay_info")) {
	            return this.billing_data.get_next_pay_info;
            }
	        return null;
        },

        next_pay_date() {
            if(this.obj_to_null(this.get_next_pay)) {
                if(!this.get_next_pay.need_pay) {
                    if (this.get_next_pay.hasOwnProperty("next_pay_human")) {
                        return this.get_next_pay.next_pay_human;
                    }
                }
            }

            return "";
        },

		head_class() {

		},
	}

}
</script>

<style scoped>

</style>
